// @ts-ignore
const HideTagsPlugin = (hiddenTags) => ({
    wrapComponents: {
        // @ts-ignore
        OperationTag: (Original) => (props) => {
            if (hiddenTags.includes(props.tag)) {
                return null;
            }
            return <Original {...props} />;
        },
    },
});

export default HideTagsPlugin;